import { Stack, Switch, Text } from "@mantine/core";
import type { AssistantAutoPointText } from "@/locales/assistant-auto-point";

interface Props {
	t: AssistantAutoPointText;
	enabled: boolean;
	disabled: boolean;
	onChange: (enabled: boolean) => void;
}

/** Saklar penunjukan otomatis saat diminta "tampilkan/tunjukkan" (#63). */
export function StyleAutoPoint({ t, enabled, disabled, onChange }: Props) {
	return (
		<Stack gap="xs" data-auto-point>
			<Text fw={600}>{t.title}</Text>
			<Text size="sm" c="dimmed">
				{t.description}
			</Text>
			<Switch
				label={t.enabled}
				checked={enabled}
				disabled={disabled}
				onChange={(e) => onChange(e.currentTarget.checked)}
				data-auto-point-enabled
			/>
		</Stack>
	);
}
